import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

import { TIME_MODIFIER_VARIANTS } from '../Toolbar/components/TimeModifier/constants';

export const ICONS = {
  [TIME_MODIFIER_VARIANTS.rounded]: {
    add: AddIcon,
    subtract: RemoveIcon
  },
  [TIME_MODIFIER_VARIANTS.square]: {
    add: '+',
    subtract: '−'
  }
};
